import { render, staticRenderFns } from "./IconGreaterThan.vue?vue&type=template&id=843eca34"
import script from "./IconGreaterThan.vue?vue&type=script&lang=ts"
export * from "./IconGreaterThan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports